import { render, staticRenderFns } from "./SparsSuppliers.vue?vue&type=template&id=5234439c"
import script from "./SparsSuppliers.vue?vue&type=script&lang=js"
export * from "./SparsSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports